// export const BaseUrl = "http://localhost/ustalar_api";

export const BaseUrl = "https://www.quron-maktabi.uz/api/";
